import { render, staticRenderFns } from "./ButtonSpinner.vue?vue&type=template&id=5b8bc42c"
import script from "./ButtonSpinner.vue?vue&type=script&lang=js"
export * from "./ButtonSpinner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports